import type {AppThunk} from '../../../../actions/types'
import {getTabsArg} from '../../../../rest/tabs'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {restApi} from '../../../../services/rest'
import {AGENTS_TAB_PARAMS_KEY} from '../../../../types'

export const preloadAgentsTabs = (): AppThunk<LoadedEndpoints> => dispatch => [
  dispatch(loadEndpoint(restApi.endpoints.getTabs, getTabsArg(AGENTS_TAB_PARAMS_KEY))),
]
